// extracted by mini-css-extract-plugin
module.exports = {"root":"PageLayout_root___P-kl","content":"PageLayout_content__3QGQM"};